/** Schedule optional work after paint; failures must not break the active page. */
export function afterIdle(work: () => Promise<unknown> | void): () => void {
  const run = () =>
    Promise.resolve()
      .then(work)
      .catch(error => console.warn('Background preload failed', error))
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(run, { timeout: 2000 })
    return () => window.cancelIdleCallback(id)
  }
  const id = window.setTimeout(run, 1200)
  return () => window.clearTimeout(id)
}
